const EVENT_NAME_PREFIX = 'IN_LIST';
export function getListMembershipEventName(objectTypeId) {
  return `${EVENT_NAME_PREFIX}-${objectTypeId}`;
}
export function isListMembershipEventName(fullyQualifiedName) {
  return fullyQualifiedName.startsWith(EVENT_NAME_PREFIX);
}